__turbopack_context__.v({
  "wrapper": "index-module__nUOuiW__wrapper",
});
